import {
  comoDiccionario,
  MOTIVOS_DE_SOLICITUD,
  NIVELES_DE_ESCOLARIDAD,
  TIPOS_DE_CONTRATO,
} from "./catalogosDeRequisicion";

const titleCase = (value: string): string =>
  value
    .replace(/[_-]+/g, " ")
    .trim()
    .toLocaleLowerCase("es-MX")
    .split(/\s+/)
    .map((word) =>
      word
        ? `${word.charAt(0).toLocaleUpperCase("es-MX")}${word.slice(1)}`
        : word
    )
    .join(" ");

const sentenceCase = (value: string): string => {
  const normalized = value
    .replace(/[_-]+/g, " ")
    .trim()
    .toLocaleLowerCase("es-MX");

  if (!normalized) return "";
  return `${normalized.charAt(0).toLocaleUpperCase("es-MX")}${normalized.slice(1)}`;
};

export const formatJobRequestArea = (value?: string | null): string =>
  value?.trim() ? sentenceCase(value) : "Sin Departamento/Área";

export const formatJobRequestSede = (value?: string | null): string =>
  value?.trim() ? titleCase(value) : "Sin sede";

export const formatJobRequestPriority = (value?: string | null): string => {
  if (!value?.trim()) return "Sin prioridad";
  const priorityMap: Record<string, string> = {
    baja: "Baja",
    media: "Media",
    alta: "Alta",
    urgente: "Urgente",
  };
  return priorityMap[value] || titleCase(value);
};

export const formatJobRequestProfile = (value?: string | null): string => {
  if (!value?.trim()) return "No especificado";
  const profileMap: Record<string, string> = {
    operativo: "Operativo",
    tecnico: "Técnico",
    administrativo: "Administrativo",
    por_proyecto: "Por proyecto",
  };
  return profileMap[value] || titleCase(value);
};

const MOTIVOS = comoDiccionario(MOTIVOS_DE_SOLICITUD);

export const formatJobRequestReason = (value?: string | null): string => {
  if (!value?.trim()) return "No especificado";
  return MOTIVOS[value] || titleCase(value);
};

const CONTRATOS = comoDiccionario([
  ...TIPOS_DE_CONTRATO,
]);

export const formatJobRequestContractType = (value?: string | null): string => {
  if (!value?.trim()) return "No especificado";
  return CONTRATOS[value] || titleCase(value);
};

const ESCOLARIDADES = comoDiccionario(NIVELES_DE_ESCOLARIDAD);

/**
 * Escolaridad pedida por la vacante. Sin esto, un valor como
 * `licenciatura_trunca` se pintaba como "Licenciatura Trunca" por el titleCase,
 * perdiendo el parentesis de pasante que es lo que aclara el requisito.
 */
export const formatJobRequestSchooling = (value?: string | null): string => {
  if (!value?.trim()) return "No especificado";
  return ESCOLARIDADES[value] || titleCase(value);
};
